import { render, staticRenderFns } from "./personalCertification.vue?vue&type=template&id=350c2a9c&scoped=true"
import script from "./personalCertification.vue?vue&type=script&lang=js"
export * from "./personalCertification.vue?vue&type=script&lang=js"
import style0 from "./personalCertification.vue?vue&type=style&index=0&id=350c2a9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c2a9c",
  null
  
)

export default component.exports